import React from "react";
import { GetData } from "../api/service";
import BreadCrumbOwn from "../component/Essentials/BreadCrumbOwn";
import { Container, Grid, Typography } from "@material-ui/core";

export default function NewsletterContainer() {
  const [data, setData] = React.useState([]);
  const [isLoaded, setIsLoaded] = React.useState(false);

  React.useEffect(() => {
    GetData(`/getnewsletters`).then((resp) => {
      setData(Array.isArray(resp) ? resp : []);
      setIsLoaded(true);
    });
  }, []);

  return (
    <div>
      <BreadCrumbOwn title="Newsletters" />
      <Container style={{ minHeight: "600px" }} className="mb-5">
        <br />
        <Typography
          variant="h5"
          style={{ margin: "0.5em 0 1em", fontWeight: 700 }}
          gutterBottom
        >
          Newsletters
        </Typography>

        {isLoaded && data.length === 0 && (
          <Typography variant="body1">
            No newsletters have been published yet.
          </Typography>
        )}

        {isLoaded &&
          data.map((el, index) => {
            const images = Array.isArray(el.featured_photo)
              ? el.featured_photo.filter((f) => f && f.fileType === "image")
              : [];
            const hasImages = images.length > 0;

            return (
              <div
                key={el.id || index}
                style={{
                  marginBottom: 40,
                  paddingBottom: 30,
                  borderBottom: "1px solid #e0e0e0",
                }}
              >
                <Typography
                  variant="h6"
                  style={{ fontWeight: 700, color: "#0B3D2E" }}
                >
                  {el.title}
                </Typography>
                <Typography
                  variant="body2"
                  style={{ color: "#566573", marginBottom: 12 }}
                >
                  {el.issue ? `${el.issue}  |  ` : ""}
                  {el.date}
                </Typography>

                <Grid container spacing={4}>
                  {hasImages && (
                    <Grid item xs={12} md={4}>
                      {images.map((img, i) => (
                        <img
                          key={i}
                          src={img.url}
                          alt={el.title}
                          style={{
                            width: "100%",
                            borderRadius: 10,
                            marginBottom: 12,
                            boxShadow: "0 6px 18px rgba(0,0,0,0.12)",
                            objectFit: "cover",
                          }}
                        />
                      ))}
                    </Grid>
                  )}

                  <Grid item xs={12} md={hasImages ? 8 : 12}>
                    <div
                      className="prose"
                      dangerouslySetInnerHTML={{ __html: el.description }}
                    ></div>
                  </Grid>
                </Grid>
              </div>
            );
          })}
      </Container>
    </div>
  );
}
